import { useCallback, useEffect, useState } from "react";
import { Lightbulb, FlaskConical, Map, CalendarClock } from "lucide-react";
import { api } from "@/lib/api";
import { ReviewBadge } from "@/components/product/ReviewBadge";

const Tile = ({ icon: Icon, label, value, color, testid, hint }) => (
  <div data-testid={testid} className="flex items-center gap-3 rounded-xl border border-[#E4E9F3] bg-white px-4 py-3">
    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl text-white" style={{ backgroundColor: color }}>
      <Icon size={17} strokeWidth={2.3} />
    </span>
    <div className="min-w-0">
      <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-[#5A6B8C]">{label}</p>
      <p className="font-numeric text-xl font-bold leading-tight text-[#14245F]">{value}{hint && <span className="ml-1 text-xs font-semibold text-[#DC2626]">{hint}</span>}</p>
    </div>
  </div>
);

export const InnovationsSummaryCard = ({ refreshKey }) => {
  const [s, setS] = useState(null);
  const load = useCallback(async () => { try { setS(await api.list("innovation-summary")); } catch { setS(null); } }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  return (
    <div data-testid="innovation-summary-card" className="mb-8 overflow-hidden rounded-2xl border border-[#E4E9F3] bg-[#F7F5FF] p-5 shadow-[0_2px_12px_rgba(20,36,95,0.05)]">
      <div className="mb-3 flex items-center gap-2">
        <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-[#7C3AED] text-white"><Lightbulb size={15} strokeWidth={2.4} /></span>
        <div>
          <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#7C3AED]">Separate from active delivery</p>
          <h3 className="font-heading text-base font-semibold text-[#14245F]">Future Innovations</h3>
        </div>
        <ReviewBadge className="ml-auto" />
      </div>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Tile testid="inn-sum-total" icon={Lightbulb} label="Total Ideas" value={s?.total_ideas ?? "—"} color="#7C3AED" />
        <Tile testid="inn-sum-validating" icon={FlaskConical} label="Being Validated" value={s?.validating ?? "—"} color="#E0A82E" />
        <Tile testid="inn-sum-roadmap" icon={Map} label="On Roadmap" value={s?.on_roadmap ?? "—"} color="#16A34A" />
        <Tile testid="inn-sum-reviews" icon={CalendarClock} label="Upcoming Reviews" value={s?.upcoming_reviews ?? "—"} color="#06B6D4" hint={s?.overdue_reviews ? `${s.overdue_reviews} overdue` : ""} />
      </div>
    </div>
  );
};
